export const ISSUE_CREATE_BUTTON_SELECTOR = 'issue-create.common.ui.footer.create-button';
export const ISSUE_CREATE_CANCEL_BUTTON_SELECTOR = 'issue-create.common.ui.footer.cancel-button';
export const ISSUE_CREATE_ISSUE_LINK_SELECTOR = 'issue-create.common.ui.footer.created-issue-link';
export const ISSUE_CREATE_IMPORT_ISSUES_BUTTON_SELECTOR =
	'issue-create.ui.modal.header.import-issues-button';

export const ISSUE_CREATE_FORM = 'issue-create.ui.modal.create-form';

export const REQUIRED_FIELDS_MISSING_SECTION_MESSAGE =
	'issue-create.ui.modal.create-form.section-messages.required-fields-message';
export const QUERY_ERROR_SECTION_MESSAGE =
	'issue-create.ui.modal.create-form.section-messages.query-error-message';
export const SUBMIT_ERROR_SECTION_MESSAGE =
	'issue-create.ui.modal.create-form.section-messages.submit-error-message';
export const UI_MODIFICATIONS_ERROR_SECTION_MESSAGE =
	'issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message';
export const INCOMPATIBLE_FIELDS_ACTIONS_LEARN_MORE_SELECTOR =
	'issue-create.common.ui.incompatible-fields-actions.learn-more';
export const INLINE_ERROR_SECTION_MESSAGE =
	'issue-create.ui.modal.create-form.section-messages.inline-create-errors';
export const INCOMPATIBLE_FIELDS_ACTIONS_SWITCH_OLD_EXPERIENCE_SELECTOR =
	'issue-create.common.ui.incompatible-fields-actions.switch-old-experience';

export const CONFIRM_DISMISS_MODAL_DISCARD_ISSUE_BUTTON =
	'issue-create.ui.modal.confirm-dismiss-modal.discard-issue-button';
export const CANCEL_DISMISS_MODAL_DISCARD_ISSUE_BUTTON =
	'issue-create.ui.modal.cancel-dismiss-modal.discard-issue-button';

export const UI_MODIFICATIONS_NOTIFICATION_SECTION_MESSAGE =
	'issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message';
